module.exports = __webpack_public_path__ + "static/images/drivingPermitExample-2.ca65dad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/public/autoInsurance/drivingPermitExample-2.png
// module id = 2ln6
// module chunks = 0